import profile from "../images/profile.jpg";

var businessData =[
    {
        id:"1",
        BLogo:profile,
        BName:"Shanghai 21",
        category:"Restaurant",
        address:"abc area Newyork",
        description:"Chinese Restaurant",
        rating:4.3,
        status:"Active"
    },
    {
        id:"2",
        BLogo:profile,
        BName:"Benz Dealer",
        category:"Automobile",
        address:"abc area Newyork",
        description:"Deals in new and used car",
        rating:3.9,
        status:"Block"
    },
    {
        id:"3",
        BLogo:profile,
        BName:"Travels",
        category:"Tour & Travel",
        address:"abc area Newyork",
        description:"Tour and travels service provider",
        rating:3.5,
        status:"Active"
    },
    {
        id:"4",
        BLogo:profile,
        BName:"Benz Dealer",
        category:"Automobile",
        address:"abc area Newyork",
        description:"Deals in new and used car",
        rating:4.7,
        status:"Block"
    },
    {
        id:"5",
        BLogo:profile,
        BName:"Shanghai 21",
        category:"Restaurant",
        address:"abc area Newyork",
        description:"Chinese Restaurant",
        rating:4.3,
        status:"Active"
    },
    {
        id:"6",
        BLogo:profile,
        BName:"Travels",
        category:"Tour & Travel",
        address:"abc area Newyork",
        description:"Tour and travels service provider",
        rating:3,
        status:"Active"
    },
    {
        id:"7",
        BLogo:profile,
        BName:"Benz Dealer",
        category:"Automobile",
        address:"abc area Newyork",
        description:"Deals in new and used car",
        rating:2,
        status:"Block"
    },
    {
        id:"8",
        BLogo:profile,
        BName:"ABC Garments",
        category:"Automobile",
        address:"abc area Newyork",
        description:"Deals in Brand's fabric",
        rating:5,
        status:"Active"
    },
    {
        id:"9",
        BLogo:profile,
        BName:"Benz Dealer",
        category:"Automobile",
        address:"abc area Newyork",
        description:"Deals in new and used car",
        rating:2.8,
        status:"Active"
    },
    {
        id:"10",
        BLogo:profile,
        BName:"ABC Garments",
        category:"Automobile",
        address:"abc area Newyork",
        description:"Deals in Brand's fabric",
        rating:4,
        status:"Block"
    },


   
];
export {businessData}